import stickybits from 'stickybits';
// add .stuck class to [js-sticky-watcher] element if it is sticked
stickybits("[js-sticky-watcher]", { useStickyClasses: true, noStyles:true, stuckClass: 'stuck', stickyClass: 'stuck' });

export default undefined;